import { SYSTEM_CONFIG_ROUTE } from "./names";

import SystemConfig from "../views/group-management/SystemConfig";

export const systemRoutes = [
  {
    path: "/system-config",
    name: SYSTEM_CONFIG_ROUTE,
    component: SystemConfig,
    meta: {
      group: "Система",
      title: "Конфигурация",
      description: "Настройка названия системы и модулей",
      icon: "mdi-cog",
      linked: true,
      breadcrumbs: [
        {
          text: "Главная",
          link: true,
          exact: true,
          to: { name: "home" }
        },
        {
          text: "Конфигурация системы",
          disabled: true,
          link: true,
          to: { name: SYSTEM_CONFIG_ROUTE }
        }
      ]
    }
  }
];
